import { BiMinus, BiPlus } from "react-icons/bi";
import { MdDelete } from "react-icons/md";
import { motion } from "framer-motion";
import { getFoodById } from "../../utils/functions";
import { useStateValue } from "../../context/StateProvider";
import { deleteCartItem, updateCartItemQty } from "../../utils/cart";
import { CartItem } from "../../../types";
import { toast } from "react-toastify";

const CartElement = ({ item }: { item: CartItem }) => {
    const [{ foodItems, cartItems }, dispatch] = useStateValue();
    const { fid, quantity } = item;
    const foodItem = getFoodById(foodItems, fid);

    const totalItems = cartItems.reduce((acc: number, curr: CartItem) => acc + curr.quantity, 0);

    const handleIncrease = () => {
        if (quantity >= 10) {
            toast.warning('Нельзя добавить больше 10 штук одной позиции');
            return;
        }

        if (totalItems >= 20) {
            toast.warning('Нельзя добавить больше 20 позиций в один заказ');
            return;
        }

        updateCartItemQty(cartItems, foodItems, item, dispatch, 1);
    };

    const handleDecrease = () => {
        if (quantity > 1) {
            updateCartItemQty(cartItems, foodItems, item, dispatch, -1);
        }
    };

    return (
        <div className="w-full p-1 px-2 rounded-lg bg-cartItem hover:shadow-md flex items-center justify-between gap-2 cursor-pointer">
            <div className="flex items-center gap-3 flex-1 min-w-0">
                <img
                    src={foodItem?.imageURL}
                    alt=""
                    className="w-16 h-16 rounded-lg object-contain flex-shrink-0"
                />

                <div className="flex flex-col min-w-0">
                    <p className="text-base text-textColor truncate">
                        {foodItem?.title}
                    </p>
                    <p className="text-sm text-headingColor font-semibold">
                        <span className="text-xs text-buttonColor">P</span> {foodItem?.price}
                    </p>
                </div>
            </div>

            <div className="flex items-center gap-2 flex-shrink-0">
                <motion.div
                    whileTap={{ scale: 0.75 }}
                    onClick={handleDecrease}
                    className={`w-6 h-6 rounded-full flex items-center justify-center ${
                        quantity > 1
                            ? 'bg-buttonColor cursor-pointer hover:bg-buttonColor/80'
                            : 'bg-gray-400 cursor-not-allowed opacity-50'
                    }`}
                >
                    <BiMinus className="text-white text-sm" />
                </motion.div>

                <p className="text-sm text-gray-50 w-8 h-8 rounded-sm bg-cartBg flex items-center justify-center cursor-default">
                    {quantity}
                </p>

                <motion.div
                    whileTap={{ scale: 0.75 }}
                    onClick={handleIncrease}
                    className={`w-6 h-6 rounded-full flex items-center justify-center ${
                        quantity < 10 && totalItems < 20
                            ? 'bg-buttonColor cursor-pointer hover:bg-buttonColor/80'
                            : 'bg-gray-400 cursor-not-allowed opacity-50'
                    }`}
                >
                    <BiPlus className="text-white text-sm" />
                </motion.div>
            </div>

            <motion.div
                whileTap={{ scale: 0.75 }}
                className="text-sm text-gray-50 w-8 h-8 rounded-lg bg-cartNumBg flex items-center justify-center flex-shrink-0 cursor-pointer transition-colors"
                onClick={() => deleteCartItem(cartItems, foodItems, item, dispatch)}
            >
                <MdDelete className="text-sm" />
            </motion.div>
        </div>
    );
};

export default CartElement;